import State, { PlacingEstimationStatus } from './State';

const initialState: State = {
    estimations: [],
    savedDraftEstimations: [],
    placedEstimations: [],
    searchQuery: '',
    filters: [],
    placingEstimationStatus: PlacingEstimationStatus.Null
};

export default initialState;



// WEBPACK FOOTER //
// ./src/application/estimations/initialState.ts